export default __webpack_public_path__ + "static/back-office-presentation-667d82f0b667d8a2cd8c567f5ae2fe7e.png";